<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Sort By</mat-label>
    <input
      autocomplete="off"
      type="text"
      formControlName="value"
      id="sortBy"
      lcsStaticSelect
      [lcsSingleSelect]="sortBySelect"
      [lcsStaticSelectValue]="form.get('value')?.value"
      [required]="true"
      />
      <lcs-static-select #sortBySelect [displayWith]="sortByDisplayWith">
        @for (sortBy of sortBy; track sortBy) {
          <lcs-option [value]="sortBy"> {{ sortBy }} </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>
  </ng-container>
